<template>
  <div>
    <!-- 登录后Layout -->
    <Layout />
  </div>
</template>
<script>
import Layout from '@/components/Layout';
export default {
  components: {
    Layout,
  },
};
</script>
